<template>
<section class="hero">

  <div class="overlay"></div>
  <div><img src="@/assets/2kexpress2k.png" class="logo">

  <h1>Fretes Comercial e Refrigerado</h1>
  <p>Coleta e entrega rápida com segurança em tempo real</p>

  <div class="buttons">
    <button class="primary" onclick="abrirForm()">Solicitar Transporte</button>

    <a href="https://wa.me/5511978673210" target="_blank">
      <button class="whats">WhatsApp</button>
    </a>
  </div></div>
  <div class="card">

  <span class="tag">Cadastro rápido</span>

  <form id="form">

    <!-- NOME -->
    <div class="input-group">
      <label>Nome</label>
      <input type="text" id="nome" placeholder="Seu nome">
    </div>

    <!-- EMAIL -->
    <div class="input-group">
      <label>Email</label>
      <input type="email" id="email" placeholder="contato@email.com">
    </div>

    <!-- TELEFONE -->
    <div class="input-group">
      <label>WhatsApp</label>
      <input type="text" id="phone" placeholder="(11) 9 9999-9999">
    </div>
    <button style="background: #E53935;" type="submit">Solicitar Orçamento</button>

  </form>

</div>

</section>

<section id="formBox" class="formBox">

  <div class="card">
    <h2>Solicitar Transporte</h2>

    <input id="origem" placeholder="Local de coleta">
    <input id="destino" placeholder="Destino">

    <select id="tipo">
      <option value="comum">Carga Comum</option>
      <option value="refrigerado">Carga Refrigerada</option>
    </select>

    <button class="primary" onclick="usarLocalizacao()">Usar minha localização</button>

    <button class="primary" onclick="tracarRota()">Calcular Rota</button>
  </div>

  <div id="map"></div>

  <div class="card">
    <button class="primary" onclick="enviar()">Enviar via WhatsApp</button>
  </div>

</section>
<section>
    <fuel-grid-item class="grid-item">

  <div class="section-header">

    <h2>Como a plataforma funciona?</h2>

    <p>
      Conectamos empresas e caminhoneiros em todo o Brasil,
      facilitando a oferta e busca por cargas de forma rápida,
      segura e sem intermediários.
    </p>

  </div>

</fuel-grid-item>
</section>
<section>
    <div> <a target="_blank"
        href="https://api.whatsapp.com/send?phone=5511978673210&amp;text=Olá%202k%20Express%202k,%20Gostaria%20de%20solicitar%20um%20orçamento."
        class="whatsapp-button"> <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg> </a> </div>
    <br><br><br><br>
    <footer class="footer-section">
      <div class="row">
        <div>
  <h3>Sobre Nós</h3>
  <p>
    A <strong>2kexpress2k</strong> é especializada em transporte rápido e seguro, oferecendo soluções eficientes para coletas e entregas com agilidade e responsabilidade. Atuamos com foco em pontualidade, cuidado com a carga e excelência no atendimento, garantindo que cada serviço seja realizado com máxima qualidade.
    <br><br>
    Nosso compromisso é atender empresas e clientes com eficiência, seja em transportes urgentes ou programados, sempre prezando pela segurança, confiança e satisfação.
  </p>
</div>
        <div class="container">
          <h3>Informações Do Negócio</h3>
          <div class="contact-info">
            <a target="_blank"
              href="https://api.whatsapp.com/send?phone=5511978673210&amp;text=Olá%202k%20Express%202k,%20Gostaria%20de%20solicitar%20um%20orçamento."
              class="icon-text"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#D81C1C"
                class="bi bi-whatsapp" viewBox="0 0 16 16">
                <path
                  d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>&nbsp; <span>(11) 9 7867-3210</span> </a>
            <a target="_blank" href="tel:11978673210" class="icon-text"><svg xmlns="http://www.w3.org/2000/svg"
                width="16" height="16" fill="#D81C1C" class="bi bi-telephone" viewBox="0 0 16 16">
                <path
                  d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>&nbsp;<span>(11) 9 7867-3210</span></a>
          </div>
               <div class="contact-info"><img class="img-responsive" src="@/assets/ssl.webp" width="0" /></div>
        </div>
        <div>
              <section class="payment-section">

                <h1 class="payment-title">
                  Aceitamos todos os cartões e Pix.
                  <strong>Temos preços imbatíveis</strong>
                </h1>
                <img style="max-width: 90%!important;" src="@/assets/cartoes.webp" width="300" />
              </section>
            </div>
          </div>
          <div></div>
      <div class="copyright-area">
        <div>
          <p style="text-align: center">&copy; {{ new Date().getFullYear() }} - Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  </section>

</template>

<script>

export default {
  data () {
    return {
      pessoa: 'pj',
      cnpj: '',
      cpf: '',
      nome: '',
      email: '',
      phone: '',

      mostrarForm: false,

      origem: '',
      destino: '',
      tipoCarga: 'comum',

      map: null,
      origemCoords: null,
      destinoCoords: null
    }
  },

  computed: {
    whatsLink () {
      return 'https://wa.me/5511978673210'
    }
  },

  methods: {
    cadastrar () {
      console.log('Cadastro:', this.$data)
      alert('Cadastrado!')
    },

    abrirForm () {
      this.mostrarForm = true
    },

    async buscarEndereco (endereco) {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${endereco}`
      )
      const data = await res.json()

      if (data.length > 0) {
        return [parseFloat(data[0].lat), parseFloat(data[0].lon)]
      }
      return null
    },

    enviar () {
      const msg = `🚛 Transporte:
Origem: ${this.origem}
Destino: ${this.destino}
Tipo: ${this.tipoCarga}`

      window.open(
        `https://wa.me/5511978673210?text=${encodeURIComponent(msg)}`
      )
    }
  }
}
</script>

<style>

/* MAP */
#map {
  height: 300px;
  margin-top: 20px;
  border-radius: 12px;
}

/* HERO SIMPLES */
.hero {
  padding: 60px;
  text-align: center;
  background: #0b0b0b;
  color: white;
}

.logo {
  width: 200px;
}

button {
  padding: 12px 20px;
  margin: 5px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.primary {
  background: #E53935;
}

.whats {
  background: #25D366;
  color: white;
}

.card {
  background: #111;
  padding: 20px;
  border-radius: 12px;
  margin-top: 20px;
}

.formBox {
  padding: 20px;
}
@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Teko:wght@300;400;500;600;700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Teko:wght@300..700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;700&display=swap);#app {
    text-align: center;
    color: #2c3e50
}

.StylableButton2545352419__container {
    align-items: center;
    display: flex;
    flex-basis: auto;
    flex-direction: row;
    flex-grow: 1;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    transition: all .2s ease,visibility 0s;
    width: 100%
}

@media only screen and (max-width: 600px) {
    .banner-container {
        right:-10px;
        top: -10px
    }
}

.rotate {
    animation: rotate 10s linear infinite
}

@keyframes rotate {
    0% {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(1turn)
    }
}

@keyframes pulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05,1.05,1.05)
    }

    to {
        transform: scaleX(1)
    }
}

@keyframes pisca {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}

@media only screen and (max-width: 600px) {
    .t .title {
        font-size:48px
    }

    .t {
        left: 5%;
        max-width: 90vw!important;
        min-height: 100%!important
    }

    .btn {
        max-width: 50vw!important;
        min-width: 50vw!important;
        font-size: .7rem
    }
}

.b1,.b2 {
    color: #fff;
    animation: pisca 1.5s infinite
}

.btn.b2:hover,.btn:hover {
    background-color: #212121
}

@media only screen and (max-width: 600px) {
    .servicos li {
        min-width:100%
    }
}

.contact-info .icon-text {
    display: flex;
    margin-bottom: 10px
}

.whatsapp-button {
    animation: pulse 4s infinite,pisca 1.5s infinite
}

.hero-app {
    position: relative;
    width: 100%;
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden
}

.hero-bg {
    /* background-image: url(/img/hero.9e0108b9.avif); */
    background-size: cover;
    background-position: 50%;
    transform: scale(1.1)
}

.hero-bg,.hero-overlay {
    position: absolute;
    width: 100%;
    height: 100%
}

.hero-overlay {
    background: rgba(0,0,0,.7)
}

.hero-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: #fff;
    padding: 20px
}

.hero-title {
    font-family: Teko,sans-serif;
    font-size: 70px;
    line-height: 1;
    margin-bottom: 10px
}

.hero-title span {
    color: #ff2d2d
}

.hero-subtitle {
    font-size: 20px;
    margin-bottom: 25px
}

.hero-btn {
    font-size: 18px;
    padding: 18px 40px;
    border-radius: 50px
}

@media(max-width: 768px) {
    .hero-title {
        font-size:42px
    }

    .hero-app {
        height: 80vh
    }
}

.img-responsive {
    width: 100%;
    max-width: 200px;
    height: auto
}

body * {
    overflow: hidden
}

body {
    font-family: Montserrat,sans-serif
}

.hero-title {
    display: block
}

.card-benefits img {
    margin-top: 50px;
    width: 100%;
    min-width: 100%;
    height: auto
}

.card-benefits {
    min-width: 80vw!important;
    max-width: 80vw!important;
    margin: 100px 0;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 50px
}

.benefits {
    list-style: none;
    padding: 0;
    margin: 0
}

.benefits li svg {
    margin: 8px
}

.benefits li {
    padding: 2px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 18px
}

.services {
    display: inline-flex;
    gap: 12px
}

.service h2 {
    font-family: Teko,Sans-serif!important;
    color: #d81c1c
}

.service p {
    color: #fff
}

.service {
    max-width: 20vw;
    background: #000;
    border-radius: 32px;
    padding: 32px
}

.icon-check {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    fill: #d81c1c;
    flex-shrink: 0
}

.title {
    color: #000!important;
    font-family: Teko,Sans-serif!important;
    font-size: 50px;
    margin: 0;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    letter-spacing: -1.5px
}

#app {
    font-family: Avenir,Helvetica,Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

nav {
    padding: 30px
}

nav a {
    font-weight: 700;
    color: #2c3e50
}

nav a.router-link-exact-active {
    color: #42b983
}

.container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column
}

.container ul {
    max-width: 50vw
}

.banner-container {
    overflow: hidden;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;
    max-width: 150px;
    top: 0;
    right: 0
}

@media only screen and (max-width: 600px) {
    .card-benefits {
        display:block
    }

    .card-benefits :not(svg) {
        min-width: 80vw!important;
        max-width: 80vw!important
    }

    .services {
        display: block;
        gap: 0
    }

    .service {
        margin-top: 10px;
        max-width: 80vw!important;
        min-width: 80vw!important
    }

    .banner-container {
        right: -10px;
        top: -10px
    }
}

.rotate {
    animation: rotate-d4f03df2 10s linear infinite
}

@keyframes rotate-d4f03df2 {
    0% {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(1turn)
    }
}

#circulo-banner:before {
    content: "";
    background-image: url(data:image/webp;base64,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);
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto
}

text {
    font-size: 19px;
    font-weight: 700;
    text-transform: uppercase
}

* {
    overflow-x: hidden;
    text-decoration: none
}

@keyframes pulse-d4f03df2 {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05,1.05,1.05)
    }

    to {
        transform: scaleX(1)
    }
}

@keyframes pisca-d4f03df2 {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}

.slides-container {
    border-top: 15px solid #ffc107;
    position: relative;
    max-width: 100vw;
    min-width: 100vw;
    left: 0!important;
    height: 600px;
    overflow: hidden
}

.slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity .5s ease-in-out;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat
}

.slide[style*="display: block;"] {
    opacity: 1
}

.g4 {
    padding: 0!important;
    margin: 0 auto!important;
    display: grid;
    max-width: 90%!important;
    grid-template-columns: repeat(4,25%);
    -moz-column-gap: 5px;
    column-gap: 5px;
    row-gap: 2.5px
}

@media only screen and (max-width: 600px) {
    .g4 {
        max-width:100%!important;
        grid-template-columns: repeat(2,50%)
    }
}

.g4 P {
    padding-right: 4px
}

.g4 img {
    max-width: 100%!important;
    min-width: 100%!important;
    width: auto;
    height: auto
}

.t {
    position: absolute;
    top: 5%;
    left: 6%;
    z-index: 10;
    max-width: 50vw!important;
    min-height: 100%!important
}

.t * {
    color: #212121!important
}

@media only screen and (max-width: 600px) {
    .t .title {
        font-size:48px
    }

    .t {
        left: 5%;
        max-width: 90vw!important;
        min-height: 100%!important
    }
}

.font-hover {
    color: #fff!important;
    font-weight: 700;
    font-size: 2.5rem;
    text-transform: uppercase
}

.banner-contato {
    display: flex;
    flex-direction: column;
    gap: 16px
}

.banner-contato * {
    color: #fff!important
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 20px 30px;
    margin: 20px auto;
    border: none;
    border-radius: 36px;
    text-decoration: none;
    font-size: .9rem;
    font-weight: 600;
    max-width: 25vw!important;
    cursor: pointer
}

@media only screen and (max-width: 600px) {
    .btn {
        max-width:70vw!important;
        min-width: 70vw!important;
        font-size: .7rem
    }
}

.b1 {
    background: #00cf4b;
    box-shadow: 0 0 21px -6px #00cf4b
}

.b1,.b2 {
    color: #fff;
    animation: pisca-d4f03df2 1.5s infinite
}

.b2 {
    background-color: #ab2424;
    box-shadow: 0 0 21px -6px #d32f2f
}

.icon32 {
    margin-right: 8px
}

.btn.b2:hover,.btn:hover {
    background-color: #212121
}

.servicos {
    display: flex;
    flex-wrap: wrap
}

.servicos li {
    min-width: 45%
}

@media only screen and (max-width: 600px) {
    .servicos li {
        min-width:50%!important
    }
}

.footer-content {
    padding: 0 5px
}

.footer-content p {
    text-align: left!important
}

.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #d5d5d5;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%
}

.row {
    display: flex;
    position: relative;
    width: 92vw;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px
}

.row div p {
    text-align: left
}

.row div {
    width: calc(33.33333% - 4px)
}

@media only screen and (max-width: 600px) {
    .row div {
        width:95%
    }
}

* {
    overflow-x: hidden!important
}

h3 {
    font-family: Teko,Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    color: #212121
}

@media only screen and (max-width: 600px) {
    h3 {
        font-size:28px
    }
}

.footer-section {
    min-width: 100vw!important;
    max-width: 100vw!important;
    background: hsla(0,0%,48%,.09);
    color: #212121
}

.contact-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-width: 55%;
    margin: 0 auto!important
}

.contact-info .icon-text {
    color: #212121!important
}

.copyright-area {
    padding: 15px 0;
    color: #212121;
    text-align: center
}

.copyright-area div {
    margin: 0 auto!important
}

.copyright {
    display: flex;
    justify-content: center
}

@media(max-width: 767px) {
    .footer-menu {
        margin-top:30px
    }
}

.whatsapp-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #00cf4b;
    width: 48px;
    height: 48px;
    padding: 20px;
    font-size: 16px;
    border-radius: 100%;
    text-decoration: none;
    animation: pulse-d4f03df2 4s infinite,pisca-d4f03df2 1.5s infinite;
    box-shadow: 0 0 21px -6px #25d366;
    transition: background-color .3s ease;
    position: fixed;
    bottom: 2vh;
    right: 5vw;
    z-index: 1000
}

.whatsapp-button:hover {
    background-color: #2aee72
}

.row {
    display: flex;
    position: relative;
    width: 92vw;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;
}
.section-header{
  width:clamp(300px, 90vw, 900px);
  margin:0 auto;
  text-align:center;
}

.section-header h2{
  font-size:clamp(22px, 3vw, 32px);
  font-weight:700;
  margin-bottom:15px;
  color:#111;
}

.section-header p{
  font-size:clamp(14px, 1.5vw, 18px);
  color:#555;
  line-height:1.6;
  max-width:700px;
  margin:0 auto;
}
*{
  margin:0;
  padding:0;
  box-sizing:border-box;
  font-family:Arial;
}

.card{
  width:100%;
  max-width:520px;
  background:white;
  border-radius:16px;
  padding:30px;
  box-shadow:0 10px 30px rgba(0,0,0,0.1);
}

.tag{
  background:#eef2ff;
  color:#4f46e5;
  padding:6px 12px;
  border-radius:20px;
  font-size:12px;
  display:inline-block;
  margin-bottom:15px;
}

h2{
  margin-bottom:20px;
}

/* INPUT */
.input-group{
  margin-bottom:15px;
}

.input-group label{
  font-size:13px;
  color:#555;
  display:block;
  margin-bottom:5px;
}

.input-group input{
  width:100%;
  padding:12px;
  border-radius:8px;
  border:1px solid #ddd;
  outline:none;
}

.input-group input:focus{
  border-color:#4f46e5;
}

/* RADIO */
.radio-group{
  display:flex;
  gap:10px;
  margin-bottom:15px;
}

.radio{
  flex:1;
  padding:12px;
  border:1px solid #ddd;
  border-radius:10px;
  text-align:center;
  cursor:pointer;
}

.radio input{
  display:none;
}

.radio.active{
  border-color:#4f46e5;
  background:#eef2ff;
}

/* BOTÃO */
button{
  width:100%;
  padding:14px;
  border:none;
  border-radius:10px;
  background:#4f46e5;
  color:white;
  font-weight:bold;
  cursor:pointer;
}

button:disabled{
  background:#ccc;
}

.hidden{
  display:none;
}
body {
  margin: 0;
  font-family: Arial;
  background: #0b0b0b;
  color: white;
}

/* HERO */
.hero {
  width: clamp(300px, 100vw, 1500px);
  position: relative;
  padding: 100px 20px;
  text-align: center;
  background: url('@/assets/2klogo.webp') center/cover no-repeat;
  overflow: hidden;
   display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 50px;
}

/* overlay escuro estilo app */
.hero .overlay {
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background: rgba(0,0,0,0.7);
  backdrop-filter: blur(4px);
}

/* conteúdo acima do overlay */
.hero * {
  position: relative;
  z-index: 2;
}

.logo {
  width: 220px;
  margin-bottom: 20px;
}

.hero h1 {
  font-size: 34px;
  font-weight: bold;
}

.hero p {
  color: #ccc;
  font-size: 16px;
}

.buttons {
  margin-top: 30px;
}

/* animação suave */
.hero h1, .hero p, .hero .buttons {
  animation: fadeUp 0.8s ease;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.hero {
  padding: 60px 20px;
  text-align: center;
}

.logo {
  width: 220px;
}

h1 {
  font-size: 28px;
}

p {
  color: #aaa;
}

/* BUTTONS */
.buttons {
  margin-top: 25px;
}

button {
  padding: 14px 22px;
  border-radius: 10px;
  border: none;
  margin: 5px;
  font-size: 15px;
  cursor: pointer;
}

.primary {
  background: #E53935;
  color: black;
}

.whats {
  background: #25D366;
  color: white;
}

/* FORM */
.formBox {
  display: none;
  padding: 20px;
  animation: fade 0.4s;
}

@keyframes fade {
  from {opacity:0; transform: translateY(10px);}
  to {opacity:1;}
}

input, select {
  width: 100%;
  padding: 12px;
  margin: 8px 0;
  border-radius: 10px;
  border: none;
}

/* MAP */
#map {
  height: 300px;
  margin-top: 20px;
  border-radius: 12px;
}

/* CARD */
.card {
  background: #111;
  padding: 15px;
  border-radius: 12px;
  margin-top: 15px;
}

/* ==============================
   📞 WHATSAPP FLOAT
============================== */
.whatsapp-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #00cf4b;
    width: 48px;
    height: 48px;
    padding: 20px;
    font-size: 16px;
    border-radius: 100%;
    text-decoration: none;
    animation: pulse-d4f03df2 4s infinite,pisca-d4f03df2 1.5s infinite;
    box-shadow: 0 0 21px -6px #25d366;
    transition: background-color .3s ease;
    position: fixed;
    bottom: 2vh;
    right: 5vw;
    z-index: 1000;
}

/* ==============================
   🦶 FOOTER
============================== */
.footer-section {
  background: #eee;
  padding: 20px;
}

.contact-info {
  text-align: center;
}

/* ==============================
   📱 RESPONSIVO
============================== */
@media (max-width: 768px) {

  .hero-app {
    height: 80vh;
  }

  .services {
    flex-direction: column;
  }

  .service {
    max-width: 80vw;
  }

  .card-benefits {
    flex-direction: column;
  }

  .g4 {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
